module.exports = __webpack_public_path__ + "static/media/9DESA22.c8b39435.jpg";